import { requests } from "../config";
import { IReceiptReportLine } from "./models/receipt";
import { IReceiptChangeStatus, IReceiptPostRequest, IReceiptReportParams } from "./models/requests";

export const Reciept = {
  // receipt?DateFrom=2&DateTo=3&CustomerID=4
  getReciepts: (data: string) => requests.get(`receipt?${data}`, 'go'),
  getRecieptByID: (id: number | string) => requests.get(`receipt/${id}`, 'go'),
  postReceipt: (data: IReceiptPostRequest) => requests.post(`receipt`, 'go', data),
  getDebt: (id: number | string) => requests.get(`receipt/debt/by_client?ClientID=${id}`, 'go'),
  changeStatus: (data: IReceiptChangeStatus[]) => requests.put(`receipt/status`, 'go', data),
  getReceiptsReport: (params: IReceiptReportParams): Promise<IReceiptReportLine[]> => {
    const query = new URLSearchParams({
      DateFrom: params.DateFrom,
      DateTo: params.DateTo,
      DateType: String(params.DateType),
      CustomerID: String(params.CustomerID),
      SellerID: String(params.SellerID),
      PaymentType: params.PaymentType,
    })
    return requests.get(`receipt/lines?${query}`, 'go')
  },
} 